import { Rate } from '../types'

export const rateData: Rate[] = [
  {
    'Land Type': 'Level Block',
    'Property Type': 'Apartments',
    Storeys: 'More than Three less than Eight',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '3405.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Apartments',
    Storeys: 'More than Three less than Eight',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2445.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '3525.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '3000.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '5287.50',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '4500.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2740.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1915.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2740.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1995.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Weatherboard',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2670.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Weatherboard',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1765.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '4005.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2872.50',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '4110.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2992.50',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Townhouse',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2325.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Townhouse',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2000.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Units',
    Storeys: 'Three',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '3000.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Units',
    Storeys: 'Three',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2000.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Apartments',
    Storeys: 'More than Three less than Eight',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '3670.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Apartments',
    Storeys: 'More than Three less than Eight',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2635.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '3800.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '3500.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '5700.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Architecturally Designed Home',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '5250.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2880.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2060.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2955.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2150.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Weatherboard',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2625.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Single',
    'External Construction Type': 'Weatherboard',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1900.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '4320.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '3090.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '4432.50',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Standard House',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '3225.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Townhouse',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2510.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Townhouse',
    Storeys: 'Two',
    'External Construction Type': 'Full Brick',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2000.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Units',
    Storeys: 'Three',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2295.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Units',
    Storeys: 'Three',
    'External Construction Type': 'Concrete structure',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '2110.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Project Home',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1095.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Project Home',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '1535.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Project Home',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1527.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Project Home',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '1803.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Project Units',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '803.00',
  },
  {
    'Land Type': 'Level Block',
    'Property Type': 'Project Units',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '1580.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Project Home',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1556.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Project Home',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '1711.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Project Home',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1655.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Project Home',
    Storeys: 'Two',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '2050.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Project Units',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'Low',
    Rate: '1664.00',
  },
  {
    'Land Type': 'Sloping Block',
    'Property Type': 'Project Units',
    Storeys: 'Single',
    'External Construction Type': 'Brick Veneer',
    'Estimated Year of Construction': 2020,
    'Quality of Finish': 'High',
    Rate: '1838.00',
  },
]
